// Entry point for the build script in your package.json

// ============================================================================
// ALL IMPORTS MUST COME FIRST IN ES6 MODULES
// ============================================================================

// jQuery removed - migrated to vanilla JS and Bootstrap 5 native components
// import jQuery from 'jquery';
// Import Popper.js for Bootstrap 5
import * as Popper from '@popperjs/core';
// Import Bootstrap 5
import * as bootstrap from 'bootstrap';
// REMOVED: Rails UJS conflicts with Turbo in Rails 7
// import Rails from '@rails/ujs'
import '@hotwired/turbo-rails';
import { Application } from '@hotwired/stimulus';
import 'trix';
import '@rails/actiontext';
// Swiper loaded via CDN in layout

// Import Tom Select for multi-select token fields (contact_tokens, property_tokens)
import 'tom-select/dist/css/tom-select.css';

// Import Trix CSS (Swiper CSS now imported via SCSS)
import 'trix/dist/trix.css';

// Swiper fixes now integrated into main SCSS files

// Import Font Awesome for admin icons
import '../../vendor/assets/javascripts/fontawesome-all.js';

// Import Stimulus controllers registration function
import { registerControllers } from './controllers';

// jQuery FileUpload removed - now using Stimulus file-upload controller

// Core framework first - import modernized utilities before other modules use them
import './lib/modern_number_helpers';
import './lib/modern_utilities';
import './lib/bc';

// Controllers in dependency order
import './lib/admin_pages';
import './lib/articles'; 
import './lib/properties';
import './lib/galleries';
import './lib/clients';
import './lib/contacts';
import './lib/listings';
import './lib/transactions';
import './lib/users';
import './lib/workflows';
import './lib/deductions';
import './lib/investments';
import './lib/tasks';
import './lib/task_lists';
import './lib/revenue';
import './lib/documents';
import './lib/mortgage';
import './lib/new_site';
// import './lib/carr-limit'; // Migrated to character_limit_controller.js

// ============================================================================
// EXECUTABLE CODE STARTS HERE (AFTER ALL IMPORTS)
// ============================================================================


// Add polyfill for requestIdleCallback (used by browser extensions)
if (!window.requestIdleCallback) {
  window.requestIdleCallback = function(callback, options) {
    return setTimeout(function() {
      var start = Date.now();
      callback({
        didTimeout: false,
        timeRemaining: function() {
          return Math.max(0, 50 - (Date.now() - start));
        }
      });
    }, 1);
  };
}

if (!window.cancelIdleCallback) {
  window.cancelIdleCallback = function(id) {
    clearTimeout(id);
  };
}

// Add comprehensive error handler at the very start to catch all JS errors
window.addEventListener('error', function(event) {
  if (event.error && event.error.message) {
    var message = event.error.message;
    if (message.includes('MutationObserver') || 
        message.includes('must be an instance of Node') ||
        message.includes('credentials-library')) {
      console.warn('Suppressed external library error:', message);
      event.preventDefault();
      return false;
    }
  }
});

// Also handle unhandled promise rejections
window.addEventListener('unhandledrejection', function(event) {
  if (event.reason && event.reason.message) {
    var message = event.reason.message;
    if (message.includes('MutationObserver') || 
        message.includes('must be an instance of Node') ||
        message.includes('credentials-library')) {
      console.warn('Suppressed external library promise rejection:', message);
      event.preventDefault();
      return false;
    }
  }
});

// jQuery global assignment removed - no longer needed
// window.$ = window.jQuery = jQuery;
// const $ = jQuery;

// Make Popper globally available for Bootstrap and other libraries
window.Popper = Popper;

// Ensure jQuery is available as a global before importing jQuery UI
if (typeof global !== 'undefined') {
  global.jQuery = jQuery;
  global.$ = jQuery;
}


// Ensure Font Awesome is ready
function convertFontAwesome() {
  if (window.FontAwesome && window.FontAwesome.dom && window.FontAwesome.dom.i2svg) {
    // Convert both <i> and <span> elements to SVG
    window.FontAwesome.dom.i2svg({
      searchPseudoElements: true
    });
  }
}

document.addEventListener('DOMContentLoaded', convertFontAwesome);

// Also convert Font Awesome after Turbo navigation (for dynamically loaded content)
document.addEventListener('turbo:load', convertFontAwesome);
document.addEventListener('turbo:frame-load', convertFontAwesome);

// Setup todo filters on turbo navigation
document.addEventListener('turbo:load', function() {
  setupTodoFiltersGlobal();
});

function setupTodoFiltersGlobal() {
  const todoForm = document.getElementById('filters');
  
  if (todoForm) {
    // Try both approaches: change events on inputs and click events on labels
    const inputs = todoForm.querySelectorAll('.btn-group-toggle input[type="checkbox"]');
    const labels = todoForm.querySelectorAll('.btn-group-toggle label');
    
    // Method 1: Listen for change events on inputs
    inputs.forEach((input, index) => {
      input.addEventListener('change', function() {
        setTimeout(() => {
          todoForm.submit();
        }, 50);
      });
    });
    
    // Method 2: Listen for click events on labels
    labels.forEach((label, index) => {
      label.addEventListener('click', function(e) {
        setTimeout(() => {
          todoForm.submit();
        }, 100);
      });
    });
  }
}

// Fix admin accordions on Turbo navigation
document.addEventListener('turbo:load', function() {
  // Only run on admin pages
  if (window.location.pathname === '/admin') {
    setTimeout(() => {
      setupAdminAccordions()
    }, 100)
  }
});

function setupAdminAccordions() {
  const isLargeScreen = window.innerWidth >= 992
  
  if (!isLargeScreen) return // Only auto-expand on desktop
  
  // Find all admin accordion sections
  const accordionSections = document.querySelectorAll('.collapse.admin-heading, .collapse.show')
  
  accordionSections.forEach((section) => {
    // Add show class
    section.classList.add('show')
    
    // Update trigger button
    const trigger = document.querySelector(`[data-bs-target="#${section.id}"]`)
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true')
      trigger.classList.remove('collapsed')
    }
    
    // Use Bootstrap 5 native API if available
    if (window.bootstrap && window.bootstrap.Collapse) {
      const collapseInstance = window.bootstrap.Collapse.getInstance(section)
      if (collapseInstance) {
        collapseInstance.show()
      }
    }
  })
}

// Swiper loaded via CDN and available as window.Swiper

// Make other libraries globally available
window.Popper = Popper;
window.bootstrap = bootstrap;

// REMOVED: Rails UJS replaced by Turbo in Rails 7
// Rails.start()

// Initialize Stimulus
const application = Application.start();
window.Stimulus = application;

// Register all Stimulus controllers
registerControllers(application);

// jQuery UI is no longer needed - we've replaced all components with modern alternatives:
// - datepicker → native HTML5 date inputs  
// - sortable → SortableJS
// - tooltip → Bootstrap tooltips

// Bootstrap 5 now includes native offcanvas support
// No need for jasny-bootstrap anymore

// Initialize the application after all modules are loaded
document.addEventListener('DOMContentLoaded', function() {
  // Disable password managers on all forms except login/session forms
  var $body = document.querySelector("body");
  if (!$body) return;
  
  // Handle controller_path format (e.g., "transactions bootstrap" -> "transactions")
  var controllerData = $body.dataset.controller;
  var controller = null;
  if (controllerData) {
    controller = controllerData.split(' ')[0].replace(/\//g, "_");
  }
  var action = $body.dataset.action;
  
  // Add comprehensive autofill prevention (except on sessions pages)
  if (controller !== 'sessions') {
    // Add autocomplete="off" to all forms and inputs
    document.querySelectorAll('form').forEach(function(form) {
      form.setAttribute('autocomplete', 'off');
    });
    
    // Add multiple autofill prevention attributes to all input fields
    document.querySelectorAll('input:not([type="password"]):not([type="hidden"])').forEach(function(input) {
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('autocorrect', 'off');
      input.setAttribute('autocapitalize', 'off');
      input.setAttribute('spellcheck', 'false');
      input.setAttribute('data-lpignore', 'true');
      input.setAttribute('data-form-type', 'other');
      input.setAttribute('data-1p-ignore', 'true'); // 1Password
    });
    
    // Nuclear option: Aggressively remove ALL LastPass interference
    function nukeLastPassIcons() {
      // Remove all LastPass DOM elements (more comprehensive selectors)
      document.querySelectorAll(`
        #lp-pom-root, 
        .lp-pom-text, 
        .lp-pom-wrapper, 
        [data-lastpass-icon-root],
        [data-lastpass-root],
        .lastpass-icon,
        [id*="lastpass"],
        [class*="lastpass"],
        [data-lp-id]
      `.replace(/\s+/g, '')).forEach(function(element) {
        element.remove();
      });
      
      // Force remove background images and reset styles on ALL inputs
      document.querySelectorAll('input[type="text"], input:not([type])').forEach(function(input) {
        // Override with !important inline styles
        input.style.setProperty('background-image', 'none', 'important');
        input.style.setProperty('background-position', 'initial', 'important');
        input.style.setProperty('background-repeat', 'initial', 'important');
        input.style.setProperty('background-size', 'initial', 'important');
        input.style.setProperty('background-attachment', 'initial', 'important');
        
        // Remove any LastPass attributes
        input.removeAttribute('data-lp-id');
        input.removeAttribute('data-lastpass-root');
        
        // Re-add our prevention attributes
        input.setAttribute('data-lpignore', 'true');
        input.setAttribute('data-form-type', 'other');
      });
    }
    
    // Run immediately
    nukeLastPassIcons();
    
    // Use MutationObserver to catch LastPass adding elements in real-time
    if (window.MutationObserver) {
      const observer = new MutationObserver(function(mutations) {
        let needsCleanup = false;
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Check if LastPass added something
              if (node.id && (node.id.includes('lastpass') || node.id.includes('lp-'))) {
                needsCleanup = true;
              }
              if (node.className && (node.className.toString().includes('lastpass') || node.className.toString().includes('lp-'))) {
                needsCleanup = true;
              }
              // Check for background image changes on inputs
              if (node.tagName === 'INPUT' && node.style.backgroundImage) {
                needsCleanup = true;
              }
            }
          });
          
          // Check for attribute changes that might indicate LastPass activity
          if (mutation.type === 'attributes' && mutation.target.tagName === 'INPUT') {
            if (mutation.attributeName && (
                mutation.attributeName.includes('lastpass') ||
                mutation.attributeName.includes('lp-') ||
                mutation.attributeName === 'data-lp-id'
              )) {
              needsCleanup = true;
            }
          }
        });
        
        if (needsCleanup) {
          nukeLastPassIcons();
        }
      });
      
      // Observe the entire document for LastPass interference
      // Check if document.body exists before observing
      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'data-lp-id', 'data-lastpass-root']
        });
      } else {
        // If body doesn't exist yet, wait for it
        document.addEventListener('DOMContentLoaded', function() {
          if (document.body) {
            observer.observe(document.body, {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['style', 'data-lp-id', 'data-lastpass-root']
            });
          }
        });
      }
    }
    
    // Fallback: Still run periodically as backup
    setInterval(nukeLastPassIcons, 2000);
  }
  

  if (window.BC && controller && window.BC[controller]) {
    var activeController = window.BC[controller];
    
    if (typeof activeController.init === 'function') {
      activeController.init();
    }

    if (action && typeof activeController[action] === 'function') {
      activeController[action]();
    }
  } else {
  }
});

// Also handle Turbo navigation
document.addEventListener('turbo:load', function() {
  
  var $body = document.querySelector("body");
  if (!$body) return;
  
  // Handle controller_path format (e.g., "transactions bootstrap" -> "transactions")
  var controllerData = $body.dataset.controller;
  var controller = null;
  if (controllerData) {
    controller = controllerData.split(' ')[0].replace(/\//g, "_");
  }
  var action = $body.dataset.action;
  
  
  if (window.BC && controller && window.BC[controller]) {
    var activeController = window.BC[controller];
    
    // Call action method if it exists (this will handle initialization)
    if (action && typeof activeController[action] === 'function') {
      activeController[action]();
    }
  }
});

// Admin page functionality with responsive behavior
document.addEventListener('DOMContentLoaded', function() {
  const LARGE_SCREEN_BREAKPOINT = 992; // Bootstrap lg breakpoint
  
  function scrollToElementOnThePage(element, scrollDuration = 500) {
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 50,
        behavior: 'smooth'
      });
    }
  }

  // Set initial state based on screen size
  function setInitialCollapseState() {
    const isLargeScreen = window.innerWidth >= LARGE_SCREEN_BREAKPOINT;
    
    // Sections that should be expanded on desktop
    const desktopExpandedSections = [
      '#panel-give-thanks-to',
      '#panel-pending-feedback', 
      '#panel-add-to-mailchimp',
      '#panel-leads'
    ];

    if (isLargeScreen) {
      // Show desktop-expanded sections
      desktopExpandedSections.forEach(selector => {
        const element = document.querySelector(selector);
        const button = document.querySelector(`[data-bs-target="${selector}"]`);
        
        if (element) {
          element.classList.add('show');
        }
        if (button) {
          button.setAttribute('aria-expanded', 'true');
          button.classList.remove('collapsed');
        }
      });
    } else {
      // Ensure all sections are collapsed on mobile
      const allSections = [
        ...desktopExpandedSections,
        '#panel-Todo',
        '#panel-Sellers',
        '#panel-Buyers', 
        '#panel-inEscrow',
        '#panel-recently-closed',
        '#panel-Future-Sellers',
        '#panel-Future-Buyers'
      ];
      
      allSections.forEach(selector => {
        const element = document.querySelector(selector);
        const button = document.querySelector(`[data-bs-target="${selector}"]`);
        
        if (element) {
          element.classList.remove('show');
        }
        if (button) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.add('collapsed');
        }
      });
    }
  }

  // Client categories navigation
  function setupCategoryNavigation() {
    var categoryLinks = document.querySelectorAll('.client-categories-list a');
    categoryLinks.forEach(function(link) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        var url = this.getAttribute('href');
        var hash = url.substring(url.indexOf('#') + 1);
        var element = document.getElementById(hash);
        
        if (element) {
          scrollToElementOnThePage(element);
          var collapsableTitle = element.querySelector('[data-bs-toggle="collapse"]');
          if (collapsableTitle && collapsableTitle.classList.contains('collapsed')) {
            collapsableTitle.click();
          }
        }
      });
    });
  }

  // Todo filters - auto-submit form when buttons are clicked
  function setupTodoFilters() {
    const todoForm = document.getElementById('filters');
    
    if (todoForm) {
      // Try both approaches: change events on inputs and click events on labels
      const inputs = todoForm.querySelectorAll('.btn-group-toggle input[type="checkbox"]');
      const labels = todoForm.querySelectorAll('.btn-group-toggle label');
      
      // Method 1: Listen for change events on inputs
      inputs.forEach((input, index) => {
        input.addEventListener('change', function() {
          setTimeout(() => {
            todoForm.submit();
          }, 50);
        });
      });
      
      // Method 2: Listen for click events on labels
      labels.forEach((label, index) => {
        label.addEventListener('click', function(e) {
          setTimeout(() => {
            todoForm.submit();
          }, 100);
        });
      });
    }
  }

  // Initialize
  setInitialCollapseState();
  setupCategoryNavigation();
  setupTodoFilters();
  
  // Handle window resize
  window.addEventListener('resize', function() {
    setInitialCollapseState();
  });
  
  // Safari-specific fix for datepicker auto-close
  document.addEventListener('change', function(event) {
    if (event.target.type === 'date' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      event.target.blur();
    }
  });
  
  // Global numeric text field validation - clear field if not a valid number
  document.addEventListener('blur', function(event) {
    if (event.target.classList.contains('numeric-text-field')) {
      const value = event.target.value.trim();
      // Check if value is not empty and not a valid integer
      if (value !== '' && (isNaN(value) || !Number.isInteger(Number(value)) || Number(value) < 0)) {
        event.target.value = '';
      }
    }
  }, true); // Use capture phase to ensure it runs before turbo handlers
});